import { Component, OnDestroy } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ICreatePassword, INewPassword } from "./register-password.interface";
import { ActivatedRoute, Router } from "@angular/router";
import { RecuperarSenhaService } from "../../../../shared/services/auth/recuperar-senha/recuperar-senha.service";
import swal from "sweetalert2";
import { Md5 } from "ts-md5";


@Component({
    selector: 'app-register-password',
    templateUrl: './register-password.component.html',
    styleUrls: ['./register-password.component.scss']
  })
export class RegisterPasswordComponent implements OnDestroy {
    private unsubscriber = new Subject();
    public form = new FormGroup({
        Password: new FormControl('', [Validators.required]),
    });
    public loading: boolean = false;
    public params: Partial<INewPassword>;
    public showPassword: boolean = false;
    public hasLowercase = false;
    public hasUppercase = false;
    public hasNumber = false;
    public hasSpecial = false;
    public hasMinLength = false;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private recuperarSenhaService: RecuperarSenhaService
    ) {
        this.route.queryParams.subscribe(params => {
            if (params['token']) {
                const revertBase64 = atob(params['token']);
                const revertJSON = JSON.parse(revertBase64)
                this.params = revertJSON;
            }
        });

        this.form.get('Password').valueChanges
        .pipe(takeUntil(this.unsubscriber))
        .subscribe((value: string) => {
        this.hasLowercase = /[a-z]/.test(value);
        this.hasUppercase = /[A-Z]/.test(value);
        this.hasNumber = /[0-9]/.test(value);
        this.hasSpecial = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(value);
        this.hasMinLength = value.length >= 8;
      });

    }

    public createPassword(form, value): void {
        if (form.invalid) return;
        this.loading = true;
        let salvar$;
        
        this.recuperarSenhaService.checkStatus(this.params.Email)
        .pipe(takeUntil(this.unsubscriber))
        .subscribe((response) => {
            if (response && response.HasPassword) {
                const formResetPassword: INewPassword = {
                    Email: this.params.Email,
                    Password: Md5.hashStr(this.params.Email.toLowerCase() + value.Password),
                    Code: this.params.Code
                }
    
                salvar$ = this.recuperarSenhaService.resetPassword(formResetPassword);
            } else {
                const formCreatePassword: ICreatePassword = {
                    Email: this.params.Email,
                    Password: Md5.hashStr(this.params.Email.toLowerCase() + value.Password),
                }
    
                salvar$ = this.recuperarSenhaService.createPassword(formCreatePassword);
            }

            salvar$
            .pipe(takeUntil(this.unsubscriber)).subscribe((response) => {
                this.loading = false;
                if (response) {
                    this.router.navigate(['/login']);
                    swal('Senha criada com sucesso!');
                }
            }, (error) => {
                this.loading = false;
                console.error(error);
                const defaultError = 'Ocorreu um erro.';
    
                if (error && error.error && error.error.ValidationResult && error.error.ValidationResult.Errors && error.error.ValidationResult.Errors[0] && error.error.ValidationResult.Errors[0].ErrorMessage) {
                    return swal(error.error.ValidationResult.Errors[0].ErrorMessage);
                }
    
                return swal(defaultError);
            });
        })

    }
    
    ngOnDestroy(): void {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/auth/components/register-password/register-password.component.ts